import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import CheckIcon from '@wix/da-ds/pkg/Icons/24x24/Check';
import Notification from '../Notifications/Notification';
import SystemNotification from '../SystemNotification';
import { NotificationQueueItem } from '../Notifications';
import s from './DeviationUnpublishedNotification.scss';

interface Props extends NotificationQueueItem {
  deviation: PapiDeviation;
}

const DeviationUnpublishedNotification: React.FC<Props> = ({ id, queueName, deviation }) => {
  const { t } = useTranslation();
  return (
    <Notification
      id={id}
      queueName={queueName}
      cardComponent={SystemNotification}
      cardProps={{
        backgroundDeviation: deviation,
        iconComponent: CheckIcon,
        actions: [
          {
            label: t('unpublish.notification.success.cta'),
            href: deviation.url,
          },
        ],
      }}
    >
      <div className={s['text']}>{t(`unpublish.notification.success.text`)}</div>
    </Notification>
  );
};

DeviationUnpublishedNotification.displayName = 'DeviationUnpublishedNotification';

export default DeviationUnpublishedNotification;
